import typeActions from 'redux/typeActions';

// Compare 1 cặp PDF với 2 file Excel nguồn chuẩn.
// payload: { excel1, excel2, pdf1, pdf2 }
const compareFiles = (payload, callback) => {
  return {
    type: typeActions.COMPARE_FILES_REQUEST,
    payload,
    callback,
  };
};

export default {
  compareFiles,
};
